import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Datenschutz() {
  return (
    <LegalPage
      title="Datenschutzerklärung"
      subtitle="DSGVO-konform · alle Daten in der EU"
      lastUpdated="22. April 2026"
      testid="page-datenschutz"
    >
      <h2>1. Verantwortliche Stelle</h2>
      <p>
        <strong>Easy Gutachter GmbH</strong>, Im Mediapark 8, 50670 Köln, Deutschland.<br />
        Datenschutz-Kontakt: <a href="mailto:datenschutz@easy-gutachter.de">datenschutz@easy-gutachter.de</a>
      </p>

      <h2>2. Welche Daten verarbeiten wir?</h2>
      <ul>
        <li><strong>Account-Daten</strong>: Name, E-Mail, Telefonnummer, Adresse, Bankverbindung, USt-IdNr.</li>
        <li><strong>Akten-Inhalte</strong>: Halterdaten, Fahrzeugdaten, Fotos, Unterschriften, Schadensbeschreibungen.</li>
        <li><strong>Technische Daten</strong>: IP-Adresse, Browser-Informationen (anonymisiert nach 30 Tagen).</li>
        <li><strong>Nutzungsdaten</strong>: Logins, geöffnete Akten, exportierte PDFs (zur Sicherheits-Auditierung).</li>
      </ul>

      <h2>3. Rechtsgrundlagen</h2>
      <p>
        Die Verarbeitung erfolgt auf Basis von <strong>Art. 6 Abs. 1 lit. b DSGVO</strong> (Vertragserfüllung),
        <strong> Art. 6 Abs. 1 lit. c DSGVO</strong> (rechtliche Verpflichtung — z. B. Aufbewahrungspflichten)
        und <strong>Art. 6 Abs. 1 lit. f DSGVO</strong> (berechtigtes Interesse — z. B. Sicherheits-Logs).
      </p>

      <h2>4. Speicherort & Auftragsverarbeiter</h2>
      <p>
        Alle personenbezogenen Daten werden ausschließlich auf Servern innerhalb der Europäischen Union verarbeitet.
        Eingesetzte Auftragsverarbeiter (z. B. Cloud-Hosting, E-Mail-Versand) sind vertraglich nach Art. 28 DSGVO gebunden.
      </p>

      <h3>Cookies & Tracking</h3>
      <p>
        Wir verwenden ausschließlich technisch notwendige Cookies (Session, CSRF). Es findet kein Tracking durch Dritte statt.
      </p>

      <h2>5. Speicherdauer</h2>
      <ul>
        <li><strong>Akten</strong>: bis zu 10 Jahre (handelsrechtliche Aufbewahrungsfristen).</li>
        <li><strong>Konto</strong>: bis 30 Tage nach Kündigung, danach Löschung oder Anonymisierung.</li>
        <li><strong>Server-Logs</strong>: 30 Tage.</li>
      </ul>

      <h2>6. Deine Rechte</h2>
      <ul>
        <li>Auskunft (Art. 15 DSGVO)</li>
        <li>Berichtigung (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch (Art. 21 DSGVO)</li>
        <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
      </ul>

      <h2>7. Sicherheit</h2>
      <p>
        Übertragung ausschließlich verschlüsselt (TLS 1.3). Passwörter werden mit bcrypt gehasht. Für sensible Felder
        (z. B. IBAN) erfolgt zusätzlich eine Server-seitige Verschlüsselung.
      </p>

      <h2>8. Änderungen dieser Erklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung zu aktualisieren, um sie an geänderte Rechtslage oder neue Funktionen
        anzupassen. Die jeweils aktuelle Fassung findest du hier — wir informieren registrierte Nutzer per E-Mail über wesentliche Änderungen.
      </p>
    </LegalPage>
  );
}
